<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.userpermission') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <UserPermissionForm
        :appRolePermissions="appRolePermissions"
        :rolePermissionList="rolePermissionList"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <BaseModalOverLimit
        :id="modalOverLimitId"
        :headerText="$t('overlimit.user.header')"
        :bodyTextUnitPrice="$t('overlimit.user.body.unitprice', { number: getCurrencyWithNumber(numberel(pricing.user, '0,0')) })"
        :bodyTextPerMonth="$t('overlimit.user.body.permonth')"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { USER_PERMISSION_TYPE } from '@/helpers/enum'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      modalOverLimitId: 'modalOverLimitId',
      form: null,
    }
  },

  computed: {
    ...mapState('appPermission', {
      appRolePermissions: 'permissionList',
    }),
    ...mapState('rolePermission', {
      rolePermissionList: 'rolePermissionList',
    }),
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 1,
    })
  },

  async mounted () {
    await this.fetchData()
    const isAvailableToCreate = this.$store.state.shop.availableToCreate.user
    if (!isAvailableToCreate) {
      $(`#${this.modalOverLimitId}`).modal('show')
    }
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('appPermission', {
      getAppPermissionList: 'getAppPermissionList',
    }),
    ...mapActions('rolePermission', {
      getRolePermissionList: 'getRolePermissionList',
    }),
    ...mapActions({
      insertEmployee: 'insertEmployee',
    }),
    ...mapActions([
      'getShopUseLimit',
      'getShopAvailableToCreate',
    ]),
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.getAppPermissionList(),
        this.getRolePermissionList(),
        this.getShopUseLimit(),
        this.getShopAvailableToCreate({ type: 'user' }),
        this.getPricing(),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getDataForm (input = {}) {
      let data = {
        'username': input.username.toLowerCase(),
        'password': input.password,
        'permission_type': input.type,
      }
      if (input.type === USER_PERMISSION_TYPE.GENERAL) {
        data.permissions = input.permissions
      } else if (input.type === USER_PERMISSION_TYPE.RELATIONAL) {
        data.permission_ids = input.permissionIds
      }
      return data
    },
    async handleSubmit (input = {}) {
      this.isSubmitted = true
      this.disabled = true
      const data = this.getDataForm(input)
      const response = await this.insertEmployee(data)
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: input.username }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({ name: 'SettingsUserList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/user/Create.vue